import { SET_STAY } from '../helpers/constants/actionsConstants';

import type { StayAction } from '../actions/types';
import type { StayState } from '../selectors/types';

const initialState: StayState = {
  adults: null,
  childrenAges: [],
};

const reducer = (
  state: StayState = initialState,
  action: StayAction,
): StayState => {
  switch (action.type) {
    case SET_STAY:
      return {
        adults: action.payload.adults,
        childrenAges: action.payload.childrenAges,
      };
    default:
      return state;
  }
};

export { initialState };

export default reducer;
